import { render, staticRenderFns } from "./DropdownOrder.vue?vue&type=template&id=4abd2418&scoped=true&"
import script from "./DropdownOrder.vue?vue&type=script&lang=js&"
export * from "./DropdownOrder.vue?vue&type=script&lang=js&"
import style0 from "./DropdownOrder.vue?vue&type=style&index=0&id=4abd2418&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd2418",
  null
  
)

export default component.exports